import React, { useEffect } from "react"
import Navbar from "../components/Navbar"
// import Hero from "../components/Hero"

import Footer from "../components/Footer"
import HomeHero from "../components/HomePage/Hero"
import Projects from "../components/HomePage/Projects"
import Team from "../components/Team"
import Services from "../components/Services"
import Clients from "../components/HomePage/Clients"
import Explore from "../components/HomePage/Explore"
import Reviews from "../components/HomePage/Reviews"
import Quality from "../components/HomePage/Quality"

// const heroContent = {
//   primaryTitle: "Crafting Cutting-Edge",
//   secondaryTitle: "Solutions and Seamless Cloud Transformation",
//   description: `  Fast-track your cloud adoption or optimize existing infrastructure.
//           Abstract your code with containers for enhanced flexibility.`,
// }

const IndexPage = () => {
  return (
    <main>
      <Navbar />
      <HomeHero />
      <Projects />
      <Quality />
      <Services />
      <Explore />
      <Clients />
      <Reviews />
      <Team />
      <Footer showContact />
    </main>
  )
}

export default IndexPage

export const Head = () => (
  <>
    <title>Home Page</title>
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />

    <link rel="preconnect" href="https://fonts.googleapis.com"></link>
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin></link>
    <link
      href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap"
      rel="stylesheet"
    ></link>
  </>
)
